var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "h-64 mt-8 mb-12 w-full rounded-lg bg-gray-50 flex flex-col items-center justify-center",
    },
    [
      _c(
        "h4",
        {
          staticClass:
            "xl:text-2xl lg:text-xl text-lg text-center text-gray-400 mb-4",
        },
        [_vm._v(_vm._s(_vm.title))]
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }